module.exports = __webpack_public_path__ + "static/media/double_roulette.4dc354db.wav";